export default __webpack_public_path__ + "static/squares-wide-8b40aab3d82e8cd32ed83bf553673b36.png";